// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"cafac88122c48211fee3","245":"90c3f4044014d521c33a","452":"8a1a8fdac1ef9e4afd9d","453":"bc83d820ce8dc0ec1058"}[chunkId] + ".js";
};